import { Flex } from '@energiebespaarders/symbols';
import _ from 'lodash';
import React, { useState } from 'react';
import { useIsTablet } from '@energiebespaarders/symbols/hooks';
import theme from '~/styles/theme';
import DesktopBreadCrumbs from './DesktopBreadCrumbs';
import MobileBreadCrumbs from './MobileBreadCrumbs';

/**
 * Capitalises the breadcrumb, splitting it in multiple words first if it is a kebab-cased string,
 * instead of a single word.
 * @example `formatBreadCrumb('first-post')` returns `First Post`
 */

export function formatBreadCrumb(breadCrumb: string): string {
  const isKebabCase: boolean = breadCrumb.split('-').length > 1;

  return isKebabCase
    ? _.upperFirst(_.lowerCase(breadCrumb.split('-').join(' ')))
    : _.capitalize(breadCrumb);
}

export function generateUrl(currentPath: string, pathnames: string[]) {
  let url = '';
  const position = pathnames.indexOf(currentPath);

  for (let i = 0; i <= position; i++) {
    url += `/${pathnames[i]}`;
  }

  return url;
}

export function formatPathnames(pathnames: string) {
  const hasQuery = pathnames.includes('?');

  return pathnames
    .split(hasQuery ? '?' : '#')[0]
    .substring(1)
    .split('/');
}

const FaqBreadcrumbs: React.FC = () => {
  const [expandMobileMenu, setExpandMobileMenu] = useState(false);

  const isTablet = useIsTablet();

  return (
    <Flex
      px={[2, 2, 4, 4]}
      py={2}
      width={1}
      style={{ backgroundColor: expandMobileMenu && theme.colors.grayLight }}
    >
      {isTablet ? (
        <MobileBreadCrumbs
          expandMobileMenu={expandMobileMenu}
          setExpandMobileMenu={setExpandMobileMenu}
        />
      ) : (
        <DesktopBreadCrumbs />
      )}
    </Flex>
  );
};

export default FaqBreadcrumbs;
